/**
 * Same behaviour as HTML title attribute but it shows right away and on touch events too
 */
import Vue from 'vue';

Vue.directive('resize-event', {
  bind(el, binding) {
    el.vResizeEventHandler = () => {
      if (el.offsetWidth !== el.vResizeEventX || el.offsetHeight !== el.vResizeEventY) {
        binding.value();
        el.vResizeEventX = el.offsetWidth;
        el.vResizeEventY = el.offsetHeight;
      }
    }
    el.vResizeEventX = el.offsetWidth;
    el.vResizeEventY = el.offsetHeight;
    el.addEventListener('touchend', el.vResizeEventHandler);
    el.addEventListener('mouseup', el.vResizeEventHandler);
    el.addEventListener('mouseleave', el.vResizeEventHandler);
  },
  unbind(el) {
    el.removeEventListener('touchend', el.vResizeEventHandler);
    el.removeEventListener('mouseup', el.vResizeEventHandler);
    el.removeEventListener('mouseleave', el.vResizeEventHandler);
  },
});
